// extracted by mini-css-extract-plugin
module.exports =  {"productMediaContainer":"pLiK7U","withBorderRadius":"C0cH_M","productImages":"mS0yET","productBadge":"ASDFqi"};